module.exports = require("@ember/modifier");